import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List, Map } from 'immutable'
import Link, { TARGET_BLANK } from '../Link/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'

function FileAttachmentsGraphQL (props) {
  const { data = List(), sectionTitle } = props

  if (!List.isList(data) || !data.size) {
    return null
  }

  return (
    <div className="file-attachments-graphql">
      <div className="file-attachments-graphql__section-title">
        <span>{sectionTitle}</span>
      </div>
      {data.map((attachment) => {
        const title = Map.isMap(attachment) && (attachment.get('fileName') || attachment.get('url'))

        return (
          <div
            key={attachment.get('uuid')}
            className="file-attachments-graphql__file"
          >
            <Link to={attachment.get('url')} target={TARGET_BLANK} className="file-attachments-graphql__file-link">
              <IconV2 type={ICON_TYPES.PDF_2} className="file-attachments-graphql__file-icon"/>
              {title}
            </Link>
          </div>
        )
      })}
    </div>
  )
}

FileAttachmentsGraphQL.propTypes = {
  data: ImmutablePropTypes.list.isRequired,
  sectionTitle: PropTypes.string.isRequired,
}

export default FileAttachmentsGraphQL
